/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/RichTextBox/theme';

export const RichTextBoxTheme = theme;
